const inputCls = "w-full bg-black/30 gold-border rounded-xl px-3 py-2.5 text-sm text-slate-100 focus:outline-none";

function Chips({ label, options, value = [], onChange, testid }) {
  const toggle = (o) => onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  return (
    <div>
      <div className="text-[11px] text-slate-400 mb-1.5">{label}</div>
      <div className="flex flex-wrap gap-1.5" data-testid={testid}>
        {options.map((o) => (
          <button type="button" key={o} onClick={() => toggle(o)}
            className={`text-[11px] px-2.5 py-1 rounded-full border transition-[background-color,border-color] ${value.includes(o) ? "btn-gold border-transparent" : "border-amber-500/25 text-slate-300"}`}
            data-testid={`${testid}-${o.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>{o}</button>
        ))}
      </div>
    </div>
  );
}

export default function ProductFields({ value, onChange, tax, prefix = "product" }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-3">
      <input value={value.name || ""} onChange={(e) => set("name", e.target.value)} placeholder="Product name *" className={inputCls} data-testid={`${prefix}-name`} />
      <select value={value.category || ""} onChange={(e) => set("category", e.target.value)} className={inputCls} data-testid={`${prefix}-category`}>
        <option value="">Primary category *</option>
        {tax.categories.map((c) => <option key={c} value={c}>{c}</option>)}
      </select>
      <Chips label="Materials" options={tax.materials} value={value.materials || []} onChange={(v) => set("materials", v)} testid={`${prefix}-materials`} />
      <Chips label="Style tags" options={tax.styles} value={value.style_tags || []} onChange={(v) => set("style_tags", v)} testid={`${prefix}-styles`} />
      <input value={value.highlight || ""} onChange={(e) => set("highlight", e.target.value)} maxLength={120} placeholder="Key highlight (one line)" className={inputCls} data-testid={`${prefix}-highlight`} />
      <textarea value={value.description || ""} onChange={(e) => set("description", e.target.value)} maxLength={300} rows={2} placeholder="Description (max 2 lines)" className={inputCls} data-testid={`${prefix}-description`} />
    </div>
  );
}
